const InstagramIcon = () => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='icons8-instagram 1'>
      <path
        id='Vector'
        d='M8.33337 3C5.57237 3 3.33337 5.239 3.33337 8V16C3.33337 18.761 5.57237 21 8.33337 21H16.3334C19.0944 21 21.3334 18.761 21.3334 16V8C21.3334 5.239 19.0944 3 16.3334 3H8.33337ZM18.3334 5C18.8854 5 19.3334 5.448 19.3334 6C19.3334 6.552 18.8854 7 18.3334 7C17.7814 7 17.3334 6.552 17.3334 6C17.3334 5.448 17.7814 5 18.3334 5ZM12.3334 7C15.0944 7 17.3334 9.239 17.3334 12C17.3334 14.761 15.0944 17 12.3334 17C9.57237 17 7.33337 14.761 7.33337 12C7.33337 9.239 9.57237 7 12.3334 7ZM12.3334 9C11.5377 9 10.7747 9.31607 10.2121 9.87868C9.64944 10.4413 9.33337 11.2044 9.33337 12C9.33337 12.7956 9.64944 13.5587 10.2121 14.1213C10.7747 14.6839 11.5377 15 12.3334 15C13.129 15 13.8921 14.6839 14.4547 14.1213C15.0173 13.5587 15.3334 12.7956 15.3334 12C15.3334 11.2044 15.0173 10.4413 14.4547 9.87868C13.8921 9.31607 13.129 9 12.3334 9Z'
        fill='#FAFAFA'
      />
    </g>
  </svg>
)

export default InstagramIcon
